// State
export const state = () => ({
  loading: false,
  gameTypes: [],
  games: { data: [] },
  gameProviders: [],
  isMaintenance: false,
  featuredGames: []
})

// Actions
export const actions = {
  // Game types
  async gameTypes({ commit }) {},

  // Game providers
  async gameProviders({ commit }) {},

  // Games
  async games({ commit }, params) {},
  // Play
  async playGame({ commit, dispatch, rootState }, game) {}
}

// Mutations
export const mutations = {
  gameTypes(state, data) {
    state.gameTypes = data
  },
  gameProviders(state, data) {
    state.gameProviders = data
  },
  games(state, data) {
    state.games = data
  },
  loading(state, type) {
    state.loading = type
  },
  gameImageNotFound(state, game) {
    // state.games.data.find(o => o.id === game.id).gsc_game_image = '/no-image.jpeg'
    const found = state.games.data.find(o => o.id === game.id)
    if (found) {
      found.gsc_game_image = '/no-image.jpeg'
      return found
    }
  },
  providerImageNotFound(state, provider) {
    state.gameProviders.find(o => o.id === provider.id).file_path = 'no-image.jpeg'
  },
  isMaintenance(state, type) {
    state.isMaintenance = type
  },
  featuredGames(state, value) {
    state.featuredGames = value
  }
}

// Getters
export const getters = {
  findProvider: state => providerCode => {
    return state.gameProviders.find(o => o.provider_code === providerCode)
  },
  gameTypes: (state, getters) => providerCode => {
    const provider = getters.findProvider(providerCode)
    if (provider) {
      return state.gameTypes.filter(o => provider.support_game_types.includes(o.code))
    } else {
      return state.gameTypes
    }
  },
  providersWithProductCode: state => productTypeCode => {
    return state.gameProviders.filter(o => o.support_game_types.includes(productTypeCode))
  },
  providersWithFilter: state => (providerCode, productTypeCode) => {
    const filtered = state.gameProviders.filter(o => o.support_game_types.includes(productTypeCode))
    if (providerCode) {
      return filtered.filter(o => o.provider_code === providerCode)
    } else {
      return filtered
    }
  },
  providerHasLobby: (state, getters) => providerCode => {
    const provider = getters.findProvider(providerCode)
    if (provider) {
      return provider.has_lobby
    } else {
      return false
    }
  }
}
